var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.text}},[_vm._v(_vm._s(_vm.handleText))])
}
var staticRenderFns = []

export { render, staticRenderFns }